export enum ExampleEntityIds {
  APPLE = 'd1df56f3-4ce3-4167-a713-c6aeba7e26f1',
  PFIZER = 'f50c4614-23dd-483b-9017-752a82e67179',
  SIEMENS = '64b93704-4f96-48a1-adfb-6fe5e66a7b5c',
  SECURITAS = '6b4dbf3e-af4e-4c2c-87e5-ba45c49e10a2',
  VAISALA = 'eba87d64-809a-41c7-8b48-e4f7ae0334f9',
  UPONOR = '4a79dab4-c296-4401-bc5b-f7a8b685e63d',
  FISKARS = 'd2ba62f5-89a9-4955-979b-8742319faa75',
  LAMOR = 'cdb920cd-2615-43e0-b5df-a3cca195454a',
  TAALERI = '7a0769db-641a-4291-b8fa-785e7d6b8f12',
  TESLA = 'cac88d31-47c6-4728-9fd4-c2a726ddea39',
  GE = '3870b1bb-28e0-4899-9219-ae8743ebc1c7',
  MAC_DONALDS = '2b7dc0c1-0ee8-49eb-854b-307553618c52',
  SHELL = '9cfff002-cc14-4b9e-a7ae-9b086d146ead',
  FORTUNE_500 = 'g-e1e94adc-201a-4c4f-a184-e2364544c955',
  FORTUNE_500_GLOBAL = 'g-f0f7171e-813d-43f3-a6b8-56aca0b298fd',
  CARGOTEC = 'a9c49483-7129-4e7e-ae12-e39a9c7b2a49',
  EURO_STOXX_50 = 'g-db277407-e19a-49f6-8f51-990a83c67017',
  NASDAQ_HELSINKI = 'g-586e7d4a-d9f0-49d8-8319-5247b0583434',
  SNP_500_ESG = 'g-9ec992d4-66ab-47ff-94f9-0a93e229001f',
  SNP_500 = 'g-6669c30c-8f03-4b2d-934b-7f64809c0cb4',
  VANGUARD_TOTAL_STOCK_MARKET_ETF = 'g-a4f6d3bb-d59d-47f5-91ce-e591d15188b5',

  BLACKSTONE_GROWTH_I = 'g-f21356cb-6d05-4e6d-bee8-1bbcc8c7aa23',
  ATOMICO_V = 'g-79ebfdd8-0ad6-4abf-a284-66b9ac26426b',

  // Companies of Blackstone Growth 1 and Atomico V, as of 2.4.2025.
  // As of 2.4.2025, these are used as EU PAI demo companies.
  ACCU_RX = 'c862e69b-117a-4f6a-bc90-2f5f6f4721fd',
  AIVEN = 'ab1ebfb1-6736-4620-b29c-d3fc2cba31b6',
  APLO = 'd446cbd6-2d88-4452-acb5-18a980efa962',
  ATTENTIVE = 'da9fc39a-7531-4391-9e2b-1fd31b58b150',
  BIRD = '54d82f87-c783-4d49-8f50-95714729f8a7',
  BITMOVIN = '66a5b851-b34a-4a9f-b364-38734a240722',
  JOB_AND_TALENT = 'a017443e-5463-444e-b51e-03c0f99e4e42',
  KATANA = 'e9b1f597-fb3c-4ae3-a1c4-a58a51edbc72',
  LAB_GENIUS = '13986789-2c88-42c9-968b-f4f82a6e21cb',
  MASTERCLASS = '54e359d4-1298-4676-93c0-7e248ba057c2',
  METTA_SPACE = '5db15b63-4eea-4372-a08a-e8dfff7718c0',
  MONDOO = '4f7eef5f-5917-4d90-8559-9fcf80c7c642',
  ONNA_TECHNOLOGIES = 'e6430001-7f53-4a4b-90d4-7d7b0c52c903',
  PACTUM = '5fb9dcb3-15f1-44e9-8232-b0bcb5909382',
  PEAKON_AP_S = 'fe1afc73-19cb-4106-8dd1-5488abefab3a',
  PSI_QUANTUM = '98d80c3f-6826-48c2-b21d-c3770a20820f',
  SCANDIT = 'ea2df8ed-fb82-4726-b259-969b03d1d9b8',
  SORARE = '1c32a2f9-d423-4ae1-891e-6809d186b538',
  AUTODESK = 'a9c59a4c-a00d-4d92-b9e9-8de14a519c16',
  WOLT_ENTERPRISES = 'a8c924ed-69e8-4b53-a23a-76d7a2e2a030',
  Y42 = '7b2227cb-33e5-4f0e-8937-4e7c8445f0f5',
  ZAPP = '829c5b60-06d7-4df5-8865-99cd9990aab0',
  TEMP_ENERGY = '2fd255e9-2b7f-4c3a-b06b-dca85ff4368d',
  _7_BREW_COFFEE = '025242c6-b778-464a-81fe-0eff80850f67',
  DYNAMO_SOFTWARE = '0221678f-2641-40d4-a355-b50a126fcf54',
  EPIDEMIC_SOUND = '52f2487d-aa7b-4ce6-a102-65e5ef09c2eb',
  GTCR = 'ce44abcb-a47d-46a5-87d9-bec310cfc00f',
  HYDROGEN_HEALTH = 'aef0950a-037f-42c5-9b56-b8875931d909',
  ISN_SOFTWARE = '3b7008ad-50da-42d6-a3a4-0aafda998cd1',
  MOLLIE = '40434816-20d7-4ea7-a71e-e3a18799eb30',
  OATLY = '56e179cf-f80c-45f6-9966-3fa5db20c86d',
  SPANX = 'db78c764-44f2-4246-9a68-f4c8282ecd4d',
  SUPERGOOP = 'bd5869b4-ab4e-4e74-a469-2ee1474b85a8',
  XPRESSBEES = 'ae6c47a9-2b1a-4712-a500-2ebb3f7b4177',

  ANTIBIOTICS = 'ANTIB',
  PAYDAY_LOANS = 'PAYLO',
  BEERS = 'BEERS',
  SUGAR_SWEETENED_SOFT_DRINKS = 'SGSTD',
  TOURISM = 'TOURI',
  VACCINATING = 'VACCA',
  HYGGE = 'HYGGE',
  READING_NEWS = 'REANE',
  FOOD_SAFETY = 'FOODO',
  PRIVATE_EQUITY_FUNDS_INVESTING_IN_CLOTHING = 'PREQFUIN',
  CORPORATE_GOVERNANCE_COMPLIANCE_CONSULTING_FOR_THE_CONSTRUCTION_INDUSTRY = 'COGOCOCE',
  REAL_ESTATE_FUNDS_INVESTING_IN_INDUSTRIAL_BUILDINGS = 'REESFUIC',
  GLASS_PROCESSING_MACHINERY_FOR_CAR_WINDOWS = 'GLWOMACA',

  // CSRD example companies
  TOTAL = 'c5747b83-f9db-4199-8fff-1a9b0e1e04ec',
  SANOFI = 'ceef7aa5-daa5-41d5-9402-b7619930cefd',
  VOLKSWAGEN = '471423c2-9633-4422-81e5-306750a76c19',
  INDITEX = '18fc3d41-49c4-4c03-9e3d-9c8bc44f29d2',

  // For CSRD financial effects launch
  EURO_STOXX_50_EXCLUDING_FINANCIAL_INSTITUTIONS = 'g-9ca05138-3cc0-4908-8fe7-b6bea48c906d',

  // For skipping SBTi targets
  ELISA = 'f5488a3f-79c8-4cf1-b1c6-3bb2dfd71757',
}

export const referenceCompanyGroupId = ExampleEntityIds.SNP_500;

export function isHardcodedExample(id: string) {
  return Object.values(ExampleEntityIds).includes(id as ExampleEntityIds);
}
